<script lang="ts">
	import transfer from '$lib/assets/images/icons/transfer.svg';
	import house from '$lib/assets/images/icons/house.svg';
	import build from '$lib/assets/images/icons/build.svg';
	import consolidated from '$lib/assets/images/icons/consolidated.svg';
	import { Splide, SplideSlide } from '@splidejs/svelte-splide';
	import Choice from '$lib/components/Global/Choice.svelte';
	import '@splidejs/splide/dist/css/splide.min.css';
	import __ from '$lib/stores/TranslationStore';
	import { lazyLoad } from '$lib/actions/lazyLoad';

	let options = {
		width: '100%',
		type: 'loop',
		gap: '2.5rem',
		lazyLoad: true,
		perPage: 4,
		arrows: false,
		breakpoints: {
			1024: {
				width: 'calc(100% + 3rem)',
				perPage: 2
			},
			768: {
				width: 'calc(100% + 3rem)',
				perPage: 2
			},
			640: {
				width: 'calc(100% + 3rem)',
				perPage: 1
			}
		}
	};
</script>

<div class="bg-primary">
	<div class="container mx-auto py-16">
		<div class="flex flex-col justify-between gap-4 text-white lg:flex-row">
			<h3 class="text-2xl lg:text-5xl">{$__('O que podemos fazer por si')}</h3>
		</div>
		<div class="flex justify-around gap-10 pt-20">
			<Splide {options}>
				<SplideSlide>
					<Choice
						image={transfer}
						category={$__('Crédito habitação')}
						title={$__('Transferência')}
						text={$__(
							'Transfira o seu crédito sem custos e poupe na prestação da sua casa. Encontramos as melhores condições praticadas no mercado.'
						)}
						link="/credito-habitacao"
					/>
				</SplideSlide>
				<SplideSlide>
					<Choice
						image={house}
						category={$__('Crédito habitação')}
						title={$__('Aquisição')}
						text={$__(
							'Poupe tempo e dinheiro. Negociamos as melhores condições de crédito habitação para si e encarregamo-nos de todo o processo.'
						)}
						link="/credito-habitacao"
					/>
				</SplideSlide>
				<SplideSlide>
					<Choice
						image={build}
						category={$__('Seguros')}
						title={$__('Seguro vida')}
						text={$__(
							'Garantimos a proteção da sua família aos melhores preços do mercado. Poupe no presente, investindo no futuro.'
						)}
						link="/seguros"
					/>
				</SplideSlide>
				<SplideSlide>
					<Choice
						image={consolidated}
						category={$__('Crédito pessoal')}
						title={$__('Consolidado')}
						text={$__(
							'Combinamos todos os seus créditos numa prestação mais baixa, para que possa ter mais folga no orçamento mensal.'
						)}
						link="/credito-pessoal"
					/>
				</SplideSlide>
			</Splide>
		</div>
	</div>
</div>
